import { Nova, PatchNovaDTO } from '../types';
import { ApiRepository } from './main repository/api.repository';

export namespace NovaService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/nova`;

  export const findOne = async ({ kearID }: { kearID: string }): Promise<Nova> => {
    return ApiRepository.Core().get<Nova>(BASE_API, {
      kearID,
    });
  };

  export const patch = async (patchNovaDatasetDTO: PatchNovaDTO): Promise<Nova> => {
    return ApiRepository.Core().patch<PatchNovaDTO, Nova>(BASE_API, patchNovaDatasetDTO);
  };
}
